export default {
  ACQUIRE: 'acquire',
  CREDIT: 'credit',
  INSURANCE: 'insurance',
  REVIEWS: 'reviews',
  SPOTLIGHT: 'spotlight',
  TEST_DRIVE: 'test-drive',
  TRADE: 'tradein',
  SPIN: 'spin',
  ECOMV2: 'e-commerce-v2',
  BUILD_AND_PRICE: 'build-and-price',
  TRADE_REPORT: 'tradein/report',
};
